var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"chatbox_me"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"time"},[_c('span',[_vm._v(_vm._s(_vm._f("timeTransform")(_vm.time)))])]),_vm._v(" "),_c('div',{staticClass:"contentbox"},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f283a9d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatbox/Chatbox_me.vue
// module id = null
// module chunks = 